export class Regex {
  public static readonly ukPostcode =
    /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;
  public static readonly anyValueExceptWhitespace = /^\S*$/;
  public static readonly email =
    /^([a-zA-Z0-9_\.\+-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})$/;
  public static readonly textArea = (maxCharacters) => {
    return new RegExp('([^\\s]+){1,' + maxCharacters + '}$', 'm');
  };
}
